import React from 'react';
import Layout from '../../components/Layout';
import Articles from '../../components/Articles';

const ArticlesIndexPage = () => (
  <Layout>
    <Articles />
  </Layout>
);

export default ArticlesIndexPage; 
